import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './section-meter-gas-meter-lg.svg';
import md from './section-meter-gas-meter-md.svg';
import sm from './section-meter-gas-meter-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.SECTION_METER_GAS_METER,
  label: 'Zwischenzähler_Gaszähler',
  shortLabel: 'Zs_Gas',
  icons: { sm, md, lg },
  component: component('section-meter-gas-meter/SectionMeterGasMeterDevicePanel.vue'),
  aggregationWidget: {
    enabled: true,
    component: component('section-meter-gas-meter/SectionMeterGasMeterAggregationWidget.vue'),
  },
  defaultMetricNames: ['currentVolume'],
  importantMetricNames: ['currentVolume'],
  aggregationMetricNames: [
    {
      name: 'currentVolume',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
  consumption: true,
}));
